import { Component, EventEmitter, Output } from '@angular/core';
import { COMPONENT_NAME } from '@app/constants/message.constants';
import { MessageAction } from '@app/models/message-action.model';
import { MessageComponent } from '@app/models/message-base.component';

@Component({
  selector: 'app-answer',
  templateUrl: './answer.component.html',
  styleUrls: ['./answer.component.scss']
})
export class AnswerComponent extends MessageComponent {
  @Output() onMessageAction = new EventEmitter<MessageAction>();
  override type = COMPONENT_NAME.ANSWER
}
